import { TextField } from '@mui/material'
import styled from 'styled-components'

export const StyledInput = styled(TextField)``

// Provide both a named and default export for compatibility
export const Input = StyledInput
export default StyledInput
